export default "__VITE_ASSET__56a3bcef__"